import React from 'react';
import PropTypes from 'prop-types';
import Header from '../header';
import SideMenu from '../sideMenu';
import MainContent from '../mainContent';
import Footer from '../footer';
import './index.scss';

const Category = ({ category, categorySlug, abTests }) => (
    <div className="category-page-container">
        <Header category={category}/>
        <div className="body row">
            <SideMenu category={category}
                categorySlug={categorySlug}
                alignedSidemenuOrder={abTests.alignedSidemenuOrder}/>
            <MainContent items={category.items}/>
        </div>
        <Footer/>
    </div>);

Header.propTypes = {
    category: PropTypes.object
};


export default Category;